<template>
  <div>
    <div class="mian">
      <!-- 头部 -->
      <!-- <div class="top">
        <img src="../assets/images/头部信息框.png" alt="" />
        <div class="info">
          <span>产品信息</span>
        </div>
        <div class="num">
          <span>01</span>
        </div>
      </div> -->
      <div class="product">
        <div class="text">
          <span class="text-top">Product picture</span>
          <span class="text-bottom">产·品·图·片</span>
        </div>
        <div class="picture">
          <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item
              v-for="(item, index) in picList"
              :key="index"
              @click="switch_image(item)"
            >
              <img
                :src="item"
                alt=""
                class="img"
                style="width: 100%; height: 100%"
              />
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <div class="goodsInfo goodsInfo2">
        <div class="name goodsInfo-text">
          {{ spObj.product_name }}
        </div>
        <div class="goodsInfo-text">
          <div class="goods-title">净含量</div>
          <div class="goodsInfo-text-num texts">
            {{ spObj.weight }}{{ spObj.weightunit }}
          </div>
        </div>
        <!-- <div class="goodsInfo-text" v-if="infoList[0]">
            <div class="goods-title">
            零售价
          </div>
          <div class="goodsInfo-text-num texts">
            {{ infoList[0].op.op.price }}元
          </div>
          </div> -->
        <div class="goodsInfo-text">
          <div class="goods-title">所属品牌商</div>
          <div class="goodsInfo-text-num texts">
            {{ spObj.barand_name }}
          </div>
        </div>
        <div class="goodsInfo-text">
          <div class="goods-title w1">区块链标识</div>
          <div class="goodsInfo-text-num texts" style="word-wrap: break-word">
            {{ listObj.txid }}
          </div>
        </div>
        <div
          class="goodsInfo-text"
          v-for="(item, index) in newArr2"
          :key="index"
        >
          <div class="goods-title">
            {{ item.key }}
          </div>
          <div class="goodsInfo-text-num texts">
            {{ item.value }}
          </div>
        </div>
      </div>
      <!-- <div class="goods-characteristic">
        <div class="goods-characteristic-inner">
          <span @click="toBlockChain"> 区块链标识：{{ listObj.txid }}</span>
        </div>
      </div> -->
      <div>
        <div class="material">
          <div class="dian">
            <div class="m-title">原料追溯</div>
          </div>
          <div class="date">
            {{ mList.ts | formant }}
          </div>
        </div>
        <div class="goodsInfo goodsInfo2">
          <div class="goodsInfo-text">
            <div class="goods-title">原料名称</div>
            <div class="goodsInfo-text-num texts">
              {{ mList2.material_name }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div class="goods-title">所属产区</div>
            <div class="goodsInfo-text-num texts">
              {{ mList2.produce_areaname }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div class="goods-title">产地</div>
            <div class="goodsInfo-text-num texts">
              {{ mList2.province }}{{ mList2.city
              }}{{ mList2.addressdetail || "" }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div class="goods-title">种类</div>
            <div class="goodsInfo-text-num texts">
              {{ mList2.speciesname }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div class="goods-title">采摘年份</div>
            <div class="goodsInfo-text-num texts">
              {{ mList2.yearname }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div class="goods-title w1">区块链标识</div>
            <div class="goodsInfo-text-num texts" style="word-wrap: break-word">
              {{ mList.txid }}
            </div>
          </div>
          <!-- <div class="goodsInfo-text">
            <div class="goods-title">地理位置</div>
            <div class="goodsInfo-text-num texts"></div>
          </div> -->
        </div>
        <div class="goods-characteristic">
          <!-- <div class="goods-characteristic-inner">
            <span @click="toBlockChain2"> 区块链标识：{{ mList.txid }}</span>
          </div> -->
        </div>
      </div>
    </div>
    <van-overlay :show="show">
      <div class="wrapper">
        <sertificate :ts="ts" :txid="txid" />
        <div style="margin-top: 10px" @click="show = false">
          <img src="../assets/images/关闭按钮.png" alt="" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import { Swipe, SwipeItem, Overlay } from "vant";
import { ImagePreview } from "vant";
import { Loading } from "vant";
import Sertificate from "../components/Sertificate.vue";
Vue.use(Overlay);
Vue.use(Loading);
Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  components: { Sertificate },

  // watch: {
  //   temInfo(curVal, oldVal) {
  //     console.log(oldVal, "oldVal");
  //     if (curVal) {
  //       this.temInfo = curVal;
  //       console.log(this.temInfo, "oldVal");
  //       console.log(this.temInfo.data_list[0]);
  //       console.log(
  //         JSON.parse(this.temInfo.data_list[0].msgItems[0].op.op),
  //         "pppppppppppp"
  //       );
  //       this.listObj = this.temInfo.data_list[0].msgItems[0];
  //       this.spObj = JSON.parse(this.temInfo.data_list[0].msgItems[0].op.op);
  //       this.picList = this.spObj.picList;

  //       this.newArr2 = this.spObj.parameters;
  //       this.mList = this.temInfo.data_list[1].msgItems[0];
  //       this.mList2 = JSON.parse(this.temInfo.data_list[1].msgItems[0].op.op);
  //       console.log(this.picList, "mList");
  //     }
  //   },
  // },
  data() {
    return {
      listObj: {},
      picList: [],
      spObj: {},
      listDataAll: [],
      list: [],
      mList: [],
      materialData: [],
      maList: [],
      mList2: {},
      info: [],
      infoList: [],
      newArr: [],
      newArr2: [],
      show: false,
      ts: "",
      txid: "",
    };
  },
  created() {
    this.listDataAll = JSON.parse(window.localStorage.getItem("defalutObj"));
    this.list = this.listDataAll.filter(
      (item) => item.trace_name === "商品信息"
    );

    this.list.forEach((item) => {
      this.list = item.msgItems;
    });
    this.listObj = this.list[0];
    this.spObj = this.list[0].op.op;
    this.picList = this.list[0].op.op.picList;
    this.mList = this.listDataAll.filter(
      (item) => item.trace_name === "原料环节"
    );
    this.mList.forEach((item) => {
      this.mList = item.msgItems[0];
    });
    this.mList2 = JSON.parse(this.mList.op.op);
    console.log("sp", this.mList.op.op);
    // localStorage.setItem(
    //   "parameters",
    //   JSON.stringify(this.list[0].op.op.parameters)
    // );
    // this.newArr = JSON.parse(window.localStorage.getItem("parameters"));
    // this.newArr2 = JSON.parse(this.newArr);
    // console.log(this.newArr);
    // this.info = JSON.parse(window.localStorage.getItem("defalutObj"));
    // this.infoList = this.info.filter((item) => item.trace_name === "交易信息");
    // this.infoList.forEach((item) => {
    //   this.infoList = item.msgItems;
    // });
    // this.materialData = JSON.parse(window.localStorage.getItem("idInObj"));
    // this.newArr = Array.from(Object.values(this.materialData), (x) => x);
    // this.maList = this.newArr.filter((item) => item.trace_name === "原料环节");
    // this.maList.forEach((item) => {
    //   this.maList = item.msgItems;
    // });
    // console.log("zzzz", this.newArr);
  },
  mounted() {},
  methods: {
    toBlockChain() {
      this.show = true;
      this.ts = this.listObj.ts;
      this.txid = this.listObj.txid;
      // this.$router.push(
      //   `/Look?ts=${this.listObj.ts}&txid=${this.listObj.txid}`
      // );
    },
    toBlockChain2() {
      this.show = true;
      this.ts = this.mList.ts;
      this.txid = this.mList.txid;
      // this.$router.push(`/Look?ts=${this.mList.ts}&txid=${this.mList.txid}`);
    },
    switch_image(img) {
      console.log(111);
      ImagePreview([img]);
    },
  },
};
</script>

<style lang="scss" scoped>
.w1 {
  width: 480px !important;
}
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mian {
  position: relative;
  width: 608px;
  margin-top: 10px;
  padding: 0 16px 0 16px;
  background-color: #fff;
  margin-bottom: 20px;
  .top {
    position: relative;
    img {
      width: 100%;
    }
    .info {
      position: absolute;
      top: 9vw;
      left: 6vw;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 0px;
      color: #fff;
      opacity: 1;
    }
    .num {
      color: transparent;
      -webkit-text-stroke: 1px #127855;
      font-size: 11vw;
      position: absolute;
      top: 15px;
      left: 240px;
    }
  }
  .m-pic {
    margin: 40px auto;
  }
  .product {
    width: 550px;
    height: 746px;
    margin: 0 auto;
    border: #02b152 solid 10px;
    .text {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-right: 45px;
      margin-top: 50px;
      padding-top: 20px;
      .text-top {
        color: #007d5f;
        font-weight: bold;
        line-height: 0px;
        opacity: 1;
        font-size: 32px;
        margin-bottom: 30px;
      }
      .text-bottom {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 0px;
        color: #000000;
        opacity: 1;
        padding-top: 20px;
      }
    }
    .picture {
      border: 2px solid #707070;
      opacity: 1;
      border-radius: 0px;
      margin: 60px auto;
      width: 428px;
      height: 512px;
      .my-swipe {
        width: 100%;
        height: 100%;
      }
    }
  }
  .goodsInfo2 {
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #919ab1;
    opacity: 1;
  }
  .goodsInfo {
    display: flex;
    flex-direction: column;
    width: 544px;
    border: 2px solid #f3f3f3;
    opacity: 1;
    margin: 0 auto;
    margin-top: 20px;
    padding-left: 30px;
    padding-right: 30px;
    margin-bottom: 36px;
    padding-bottom: 30px;
    .goodsInfo-text-num {
      white-space: pre-line;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .goodsInfo-text-num2 {
      width: 410px;
      color: #000;
      display: -webkit-box;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    .name {
      height: 40px;
      font-size: 28px;
      margin-bottom: 20px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #000000;
      opacity: 1;
    }
    .goodsInfo-text {
      margin-top: 30px;
      .goods-title {
        width: 140px;
      }
      .goods-title2 {
        width: 130px;
      }
      display: flex;
    }
    .texts {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      margin-left: 60px;
      color: #000000;
      opacity: 1;
    }
  }
  .goods-characteristic {
    width: 536px;
    margin: 0 auto;
    padding-bottom: 20px;
    .goods-characteristic-inner {
      margin: 0 auto;
      line-height: 38px;
      padding: 12px 30px;
      font-size: 28px;
      color: #11745f;
      border: 1px solid #11745f;
      border-radius: 32px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .material {
    display: flex;
    justify-content: space-between;
    width: 548px;
    height: 49px;

    align-items: center;
    margin: 0 auto;
    border-bottom: 2px solid #e8e8e8;
    .dian {
      .m-title {
        width: 112px;
        height: 40px;
        font-weight: 400;
        line-height: 0px;
        margin-left: 15px;
        margin-top: 5px;
      }
      width: 12px;
      height: 12px;
      background: #000000;
      border-radius: 50%;
      opacity: 1;
      margin-right: -330px;
      font-size: 28px;
    }
    .date {
      width: 250px;
      height: 28px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 28px;
      color: #919ab1;
      opacity: 1;
    }
  }
}
</style>